/**
 * Service for managing meeting phases
 * Handles phase generation, navigation, and timing logic
 */
export class PhaseService {
    /**
     * Generate phases based on settings
     * @param {Object} settings - Application settings
     * @returns {Array} Array of phase objects
     */
    static generatePhases(settings) {
        const basePhases = [
            {
                title: "Deadline",
                description: "Discussione delle scadenze imminenti",
                maxTime: settings.deadlineDuration * 60,
                type: 'deadline'
            },
            {
                title: "Aggiornamento Progetti",
                description: "Stato di avanzamento dei progetti in corso",
                maxTime: settings.projectDuration * 60,
                type: 'projects'
            }
        ];

        const personalPhases = this.generatePersonalPhases(settings);
        return [...basePhases, ...personalPhases];
    }

    /**
     * Generate personal update phases
     * @param {Object} settings - Application settings
     * @returns {Array} Array of personal phase objects
     */
    static generatePersonalPhases(settings) {
        let teamMembers = [...settings.teamMembers];
        
        if (settings.randomOrder) {
            teamMembers = this.shuffleArray(teamMembers);
        }

        return teamMembers.map((member, index) => ({
            title: `Aggiornamento Personale - ${member}`,
            description: `Aggiornamento individuale (${settings.personalDuration} minuti)`,
            maxTime: settings.personalDuration * 60,
            type: 'personal',
            memberIndex: index,
            memberName: member
        }));
    }

    /**
     * Shuffle array using Fisher-Yates algorithm
     * @param {Array} array - Array to shuffle
     * @returns {Array} Shuffled array
     */
    static shuffleArray(array) {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    }

    /**
     * Get phase by index with bounds checking
     * @param {Array} phases - Array of phases
     * @param {number} index - Phase index
     * @returns {Object|null} Phase object or null if invalid
     */
    static getPhaseByIndex(phases, index) {
        if (index < 0 || index >= phases.length) {
            return null;
        }
        return phases[index];
    }

    /**
     * Check if phase is the last one
     * @param {Array} phases - Array of phases
     * @param {number} currentIndex - Current phase index
     * @returns {boolean} True if last phase
     */
    static isLastPhase(phases, currentIndex) {
        return currentIndex >= phases.length - 1;
    }

    /**
     * Check if phase is the first one
     * @param {number} currentIndex - Current phase index
     * @returns {boolean} True if first phase
     */
    static isFirstPhase(currentIndex) {
        return currentIndex <= 0;
    }
}